import { useRef, useState, useCallback } from 'react';
import { Drawer } from '@navi/web-ui/lib/primitives';
import { DrawerFooter } from '@cp/src/components/Drawers/DrawerFooter';
import AllocationExperimentForm from './AllocationExperimentForm';
import { useSelector } from 'react-redux';
import { RootState } from '@cp/src/store';

interface IExperimentDrawerProps {
  isDrawerOpen: boolean;
  onClose: () => void;
  isEditPage?: boolean;
  setIsDrawerOpen: (value: boolean) => void;
}

const ExperimentDrawer = (props: IExperimentDrawerProps) => {
  const { isDrawerOpen, onClose, isEditPage = false, setIsDrawerOpen } = props;
  const [isOutsideClick, setIsOutsideClicked] = useState(false);
  const [isSubmitButtonDisabled, setIsSubmitButtonDisabled] = useState(true);
  const allocationExperimentFormRef = useRef<any>(null);
  const [isDirtyField, setIsDirtyField] = useState(false);

  const handleSubmitClick = useCallback(() => {
    if (allocationExperimentFormRef?.current) {
      allocationExperimentFormRef.current.submitForm();
    }
  }, []);

  const handleExitYesClick = () => {
    setIsOutsideClicked(false);
    onClose();
  };

  const handleExitNoClick = () => {
    setIsOutsideClicked(false);
  };

  const toggleOutsideClick = () => {
    if (isDirtyField) {
      setIsOutsideClicked(true);
    } else {
      setIsOutsideClicked(false);
      onClose();
    }
  };

  const isFormLoading = useSelector((state: RootState) => state?.fieldAllocation?.isLoading);

  return (
    <Drawer
      open={isDrawerOpen}
      headerText={isEditPage ? 'Edit Experiment' : 'Create Experiment'}
      showHeaderDivider={true}
      usePadding={false}
      contentClasses="overflow-auto"
      onClose={isDirtyField ? toggleOutsideClick : onClose}
      onOutSideClick={toggleOutsideClick}
      className="!w-[400px]"
      disableOutsideClick={isDirtyField}
      footerContainerClasses={isOutsideClick ? '!bg-[var(--navi-color-red-bg)]' : ''}
      footer={
        <DrawerFooter
          handleSubmitClick={handleSubmitClick}
          isSubmitButtonDisabled={isSubmitButtonDisabled || isFormLoading}
          handleExitYesClick={handleExitYesClick}
          handleExitNoClick={handleExitNoClick}
          onClose={onClose}
          toggleOutsideClick={toggleOutsideClick}
          isDirtyField={isDirtyField}
          isOutsideClick={isOutsideClick}
          isEditPage={isEditPage}
          buttonTitle={isEditPage ? 'Update experiment' : 'Create experiment'}
        />
      }
    >
      <section>
        <AllocationExperimentForm
          ref={allocationExperimentFormRef}
          onClose={onClose}
          isDrawerOpen={isDrawerOpen}
          setIsSubmitButtonDisabled={setIsSubmitButtonDisabled}
          setIsDirtyField={setIsDirtyField}
          setIsDrawerOpen={setIsDrawerOpen}
          isEditPage={isEditPage}
        />
      </section>
    </Drawer>
  );
};

export default ExperimentDrawer;
